<template>
    <v-select ref="vselect"
                :options="selectOptions"
                :on-change="onChange"
                :clearSearchOnSelect="true"
                :value="selectedOption"
                :loading="loading"
                :selectOnTab="true">
    </v-select>
</template>

<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import axios from 'axios';

    Vue.component('v-select', vSelect)

    export default {
        data: function () {
            return {
                selectedOption: null,
                selectOptions: [],
                loading: false,
            };
        },
        components: { vSelect },
        props: {
            value: Number,
            isOutlook: Boolean
        },
        methods: {
            // called when an item is selected
            onChange(item) {
                if (item !== null) {
                    this.$emit('input', item.value);
                } else {
                    this.$emit('input', null);
                }
            },
        },
        // fetches list of users when the component is created.
        created() {
            var url = "/core/api";
            var authHeader = "";
            this.loading = true;
            if (this.isOutlook) {
                url = this.$store.state.keaUrl + url + "/branches/user";
                authHeader = { headers: { "Authorization": "Bearer " + this.$store.state.accessToken } };
            } else  {
                url += "/branches/user";
            }
            axios.get(url, authHeader)
                .then(response => {
                    var branches = response.data;
                    var self = this;
                    branches.forEach(function (b) {
                        var option = { label: b.name, value: b.id };
                        self.selectOptions.push(option);
                        if (b.id == self.value) {
                            self.selectedOption = option;
                        }
                    });
                    this.loading = false;
                })
        }
    };
</script>

<style lang="scss">
    @use "vselect-styles.scss";
</style>
